/** Comprovante de pagamento (fatura PAGA) — Pix Banco Inter ou Cartão via Mercado Pago. */
const fmtBRL = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" }) : "—");
const L = { fontSize: 8, color: "#555", textTransform: "uppercase" };

const FORMAS = {
  CARTAO: ["Cartão de crédito", "Mercado Pago (cartão)"],
  PIX: ["Pix", "Banco Inter (077)"],
  PIX_MP: ["Pix", "Mercado Pago (histórico)"],
  MANUAL: ["Baixa manual", "Administração VM Piabetá"],
};

export default function ComprovantePagamento({ fatura, contrato, beneficiario }) {
  const [forma, processador] = FORMAS[fatura?.pago_metodo] || FORMAS.MANUAL;
  const cartao = fatura?.pago_metodo === "CARTAO";
  const linhas = [
    ["Pagador", contrato?.razao_social],
    ["CPF/CNPJ", contrato?.cnpj],
    ["Competência", fatura?.competencia],
    ["Vencimento", String(fatura?.vencimento || "").slice(0, 10).split("-").reverse().join("/")],
    ["Forma de pagamento", cartao && fatura?.pago_parcelas ? `${forma} · ${fatura.pago_parcelas}x` : forma],
    ["Processado por", processador],
    ["Nº da transação", fatura?.pago_transacao || "—"],
    ["Pago em", fmtDT(fatura?.pago_em)],
  ];
  return (
    <div className="print-container" data-testid="comprovante-pagamento" style={{ fontFamily: "Arial, sans-serif", background: "white", color: "black", padding: 12, border: "1px solid #000" }}>
      <div style={{ borderBottom: "2px solid #000", paddingBottom: 6, marginBottom: 8 }}>
        <div style={{ fontWeight: 900, fontSize: 14 }}>Comprovante de pagamento</div>
        <div style={{ fontSize: 9 }}>{beneficiario?.razao_social} · CNPJ {beneficiario?.cnpj}</div>
      </div>
      {linhas.map(([k, v]) => (
        <div key={k} style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 10, padding: "3px 0", borderBottom: "1px dotted #999" }}>
          <span style={L}>{k}</span><b style={{ textAlign: "right", wordBreak: "break-all" }}>{v || "—"}</b>
        </div>
      ))}
      <div style={{ marginTop: 10, textAlign: "right" }}>
        <div style={L}>Valor pago</div>
        <div style={{ fontSize: 18, fontWeight: 900 }} data-testid="comprovante-valor">{fmtBRL(fatura?.pago_valor_recebido ?? fatura?.valor_total)}</div>
      </div>
    </div>
  );
}
